(function() {
    'use strict';

    angular.module('vhols')

        .directive('affinityPromoCodes', ['affinityService', 'TrackingService', 'TRACKING_CONSTANTS',
            function(affinityService, TrackingService, TRACKING_CONSTANTS) {
            return {
                scope: {
                },
                link: function($scope, $element) {
                    var s3url = "//s3-eu-west-1.amazonaws.com",
                        element = $element[0];

                    $scope.step = 1;
                    $scope.partners = {};
                    $scope.selectedPartner = undefined;
                    $scope.member = {};
                    $scope.promoCode = undefined;
                    $scope.error = false;
                    $scope.submitting = false;

                    affinityService.getPartners().then(function(result) {
                        $scope.partners = result;
                    }, function(error) {
                        console.error('No affinity partners found');
                    });

                    $scope.selectPartner = function(partner) {
                        $scope.selectedPartner = partner;
                        $scope.step = 2;
                    };

                    $scope.goToStep = function(id) {
                        $scope.step = id;
                        if (element.getBoundingClientRect().top < 0) {
                            element.scrollIntoView();
                        }
                    };

                    $scope.partnerLogo = function(partner) {
                        if (partner && !!partner.logo) {
                            return s3url + '/' + partner.logo.awsBucketName + '/' + partner.logo.awsBucketKey;
                        } else {
                            return "";
                        }
                    };

                    $scope.clearForm = function() {
                        $scope.member = {};
                        $scope.error = false;
                        $scope.errors = {};
                        $scope.promoCode = undefined;
                    };

                    $scope.doSubmit = function() {
                        $scope.submitting = true;
                        $scope.member.affinityPartnerId = $scope.selectedPartner.affinityPartnerId;
                        affinityService.postMember($scope.member).then(successCallback, errorCallback);
                    };

                    $scope.trackEmail = function($event) {
                        TrackingService.snipeEmail(getAffinityCategoryName(), $event.target.value);
                    };

                    function successCallback(response) {
                        $scope.submitting = false;
                        $scope.error = false;
                        if (response.data) {
                            $scope.promoCode = response.data.promoCode.code;
                            $scope.step = 3;
                            trackFormSubmit();
                            var topDiv = element.getElementsByClassName('underline-center')[0];
                            if (topDiv.getBoundingClientRect().top < 0) {
                                topDiv.scrollIntoView();
                            }
                        }
                    }

                    function errorCallback(response) {
                        $scope.submitting = false;
                        $scope.error = true;
                        $scope.errors = response.status === 400 && response.data;
                        var errorContainer = element.getElementsByClassName('apc-messaging')[0];
                        if (errorContainer.getBoundingClientRect().top < 0) {
                            errorContainer.scrollIntoView();
                        }
                    }

                    function trackFormSubmit() {
                        TrackingService.formSubmit(getAffinityCategoryName(), TRACKING_CONSTANTS.submitForm, $scope.promoCode);
                    }

                    function getAffinityCategoryName() {
                        return 'Affinity promo code - ' + $scope.selectedPartner.name;
                    }
                },
                templateUrl: 'template/directives/affinity-promo-codes.html'
            };
        }]);
})();
